// let navElem = document.getElementsByTagName('nav')
let sidebar = document.getElementById('sidebar');
let modalToPrint = document.getElementsByClassName('modal-to-print');
let hidingElems = document.getElementsByClassName('hiddenForPrint');
let mainContainerRoute = document.getElementsByClassName(
  'main-container-route',
);
let mainContainer = document.getElementsByClassName('main-container');
// let sidebarElems = document.getElementsByClassName('cp-out-sidebar-vertical')

const beforePrinting = () => {
  for (const elem of hidingElems) {
    elem.classList.toggle('hidden');
  }
  for (const elem of mainContainer) {
    elem.style.marginLeft = '0px';
    elem.style.backgroundColor = 'white';
    console.log(elem);
  }
  for (const elem of mainContainerRoute) {
    elem.style.backgroundColor = 'white';
    console.log(elem);
  }
  for (const elem of modalToPrint) {
    elem.style.width = '100%';
    elem.style.height = '100%';
    console.log(elem);
  }

  // navElem[0].classList.toggle('hidden')
  // sidebarElems[0].classList.toggle('hidden')
};
const afterPrinting = () => {
  document.title = 'Yerlem';
  for (const elem of hidingElems) {
    elem.classList.toggle('hidden');
  }
  for (const elem of mainContainer) {
    elem.style.marginLeft = '20px';
    elem.style.backgroundColor = '#F8F8F8';
    console.log(elem);
  }
  for (const elem of mainContainerRoute) {
    elem.style.backgroundColor = '#F8F8F8';
    console.log(elem);
  }
  // navElem[0].classList.toggle('hidden')
  // sidebarElems[0].classList.toggle('hidden')
};

// ratio'yu 0.0 (tamamen yeşil) ile 1.0 (tamamen kırmızı) arasında bir değer
/* function lerp(start, end, ratio) {
    return start * (1 - ratio) /2;
} */
// function lerpColor(ratio) {
/*  let red = Math.round(lerp(0, 255, ratio));
 let green = Math.round(lerp(255, 0, ratio));
 return 'rgb(' + red + ',' + green + ',0)'; */
/*     let hue = Math.round(lerp(120, 360, ratio));
    if (hue >= 360) hue -= 360;
    return 'hsl(' + hue + ', 100%, 50%)';
} */
function lerpColor(value) {
  var red, green, blue;

  if (value <= 50) {
    red = 255;
    green = Math.round((value / 50) * 128);
    blue = 0;
  } else {
    red = Math.round(((100 - value) / 50) * 255);
    green = 175;
    blue = 0;
  }

  // RGB değerini oluştur
  var color = 'rgb(' + red + ',' + green + ',' + blue + ')';

  return color;
}

export { beforePrinting, afterPrinting, lerpColor };
